<script setup>

import {computed} from "vue";

const emit = defineEmits(['click']);
const className = computed(() => {
  return 'close-button'

})
</script>

<template>
    <button v-on:click="emit('click')" v-bind:class="className">
        <span class="cb__cross"></span>
        <span class="cb__text">
            <slot></slot>
        </span>
    </button>
</template>
